var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8789 18L18 15.8789L11.1211 8.99998L18 2.12108L15.8789 -9.27154e-08L9.00002 6.8789L2.12108 -6.9409e-07L-4.14636e-07 2.12108L6.8789 8.99998L-1.01601e-06 15.8789L2.12108 18L9.00002 11.1211L15.8789 18Z",
    fill: "#714FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCross);
export default __webpack_public_path__ + "static/media/new-cross.87e6ce47e63492a925452f4cc7c58595.svg";
export { ForwardRef as ReactComponent };